'use strict';

var UserExclusionRulesController = function UserExclusionRulesController($scope, dataRetrieverService, userExclusionRulesService) {
  dataRetrieverService.getDataRetriever('SYSTEM_STATUS_SCREEN', 'user-exclusion-rules-mode').setCustomSearchCriteriaRules([]);
  $scope.makeExportToCsv = function (data) {
    userExclusionRulesService.exportToCsv(data);
  };
  $scope.customRemove = function (rowsToBeRemovedFromServer) {
    userExclusionRulesService.remove(rowsToBeRemovedFromServer);
  };
  $scope.customSave = function (rows) {
    return userExclusionRulesService.save(rows);
  };
};
UserExclusionRulesController.$inject = ['$scope', 'DataRetrieverService', 'UserExclusionRulesService'];
module.exports = UserExclusionRulesController;